const serverUrl = 'http://localhost:20001'
const mediaUrl = 'https://media.cdyssjkj.com:8443'

const productMdseStateList = [{
  value: 0,
  label: '企业用户可见'
}, {
  value: 1,
  label: '个人用户可见'
}, {
  value: 2,
  label: '下架产品'
}, {
  value: 1001,
  label: '测试使用'
}]
const orderPaymentType = [{
  value: -1,
  label: '全部'
}, {
  value: 100,
  label: '支付宝'
}, {
  value: 101,
  label: '微信支付'
}, {
  value: 111,
  label: '积分支付'
}, {
  value: 1001,
  label: '测试模式支付'
}]
const orderStatePayment = [{
  value: -1,
  label: '全部'
}, {
  value: 0,
  label: '未支付'
}, {
  value: 1,
  label: '支付成功'
}, {
  value: 2,
  label: '支付失败'
}]
const appstore = {
  url_ios: 'https://apps.apple.com/cn/app/id1438520028#?platform=iphone',
  url_android: 'https://www.wandoujia.com/apps/7877618',
  url_weapp: 'weixin://dl/business/?t=9SvVgkoopMa'
}
export default {
  serverUrl,
  mediaUrl,
  productMdseStateList,
  orderPaymentType,
  orderStatePayment,
  appstore
}



// WEBPACK FOOTER //
// ./src/utils/global.js